module.exports = "/fonts/Flaticon2.svg?e1e2b6e05bbfd279181c693555c61bad";